import qs from 'qs';

import { FILTERS_STORAGE_ROOT_KEY } from './clearFiltersStorage';

export const URL_PREFIX = 'filters';

// Плоский объект (не массив/null)
export function asRecord(value: unknown): Record<string, unknown> | null {
  if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
    return value as Record<string, unknown>;
  }
  return null;
}

/*
Извлекает из корня «filters» ключи своей области провайдера: поддерево «filters[urlKey]» либо скалярные/массивные
записи плоского провайдера (вложенные объекты — чужие urlKey-области).
Смешивание плоского и namespaced провайдеров на одной адресной строке вне контракта — делящим URL нужен urlKey у всех участников
*/
export function extractOwnFilters(
  filtersRoot: Record<string, unknown>,
  urlKey: string | undefined,
): Record<string, unknown> {
  if (urlKey) return asRecord(filtersRoot[urlKey]) ?? {};
  const own: Record<string, unknown> = {};
  Object.entries(filtersRoot).forEach(([key, value]) => {
    if (!asRecord(value)) own[key] = value;
  });
  return own;
}

// Тип скаляра восстанавливается по типу дефолта — без эвристик над самой строкой
function typedUrlValue(value: string, defaultFilterValue: unknown): unknown {
  if (typeof defaultFilterValue !== 'number') return value;
  const numeric = Number(value);
  return Number.isNaN(numeric) ? value : numeric;
}

function parseUrlFilters(
  search: string,
  urlKey: string | undefined,
  defaultFilters: Record<string, unknown>,
): Record<string, unknown> | null {
  const filtersRoot = asRecord(qs.parse(search, { ignoreQueryPrefix: true })[URL_PREFIX]);
  if (!filtersRoot) return null;
  const result: Record<string, unknown> = {};
  Object.entries(extractOwnFilters(filtersRoot, urlKey)).forEach(([key, value]) => {
    if (asRecord(value)) return; // мусорная вложенность из ручных ссылок в фильтры не попадает
    // Фильтры массивов (ID и т.п.) строковые; числовые массивы (напр. statuses) нормализуются потребителем
    result[key] = typeof value === 'string' ? typedUrlValue(value, defaultFilters[key]) : value;
  });
  return Object.keys(result).length > 0 ? result : null;
}

// Разбирает JSON-строку в объект
function parseJsonRecord(value: string | null): Record<string, unknown> | null {
  if (!value) return null;
  try {
    return asRecord(JSON.parse(value));
  } catch {
    return null;
  }
}

// Источник сохранённых фильтров: приоритет у URL (своя область), при чистом заходе — чтение из localStorage (если задан storageKey)
export function readSavedFilters(
  storageKey: string | undefined,
  urlKey: string | undefined,
  search: string,
  defaultFilters: Record<string, unknown>,
): Record<string, unknown> | null {
  const fromUrl = parseUrlFilters(search, urlKey, defaultFilters);
  if (fromUrl) return fromUrl;
  if (!storageKey) return null;
  try {
    const rootMap = parseJsonRecord(localStorage.getItem(FILTERS_STORAGE_ROOT_KEY));
    if (!rootMap) return null;
    return asRecord(rootMap[storageKey]);
  } catch {
    return null;
  }
}
